import { getTypedT } from '~/shared/helpers/18n-helpers';
import { useTranslation } from '~/shared/libs/i18n/client-side';
import type { NameSpace } from '~/universal/constants';

const useTypedTranslation = (ns: NameSpace | readonly NameSpace[]) => {
  const { t: translate } = useTranslation(ns);

  return getTypedT(translate);
};

export default useTypedTranslation;
